var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataList',{attrs:{"title":"Джерела Коштів","resource":"payment-sources","columns":_vm.columns,"get-items-fn":_vm.getPaymentSources,"search-label":'Пошук за назвою джерела коштів'}})}
var staticRenderFns = []

export { render, staticRenderFns }